export class ApiUrls {
  public static readonly baseUrl = process.env.REACT_APP_API_BASE_URL;
  public static readonly countries =
    ApiUrls.baseUrl + "/api/transaction/countries";
  public static readonly airports =
    ApiUrls.baseUrl + "/api/transaction/airports";
  public static readonly customers =
    ApiUrls.baseUrl + "/api/transaction/customers";

  public static readonly errortypes =
    ApiUrls.baseUrl + "/api/transaction/errortypes";
  public static readonly operationalStatus =
    ApiUrls.baseUrl + "/api/transaction/operationalstatus";

  public static readonly transactions = ApiUrls.baseUrl + "/api/transaction";

  public static readonly miTransactions =
    ApiUrls.baseUrl + "/api/transaction/midata";

  public static readonly details =
    ApiUrls.baseUrl + "/api/transaction/transactionid?transactionid=";

  public static readonly editDetails =
    ApiUrls.baseUrl + "/api/transaction/edit/transactionid?transactionid=";

  public static readonly miDetails =
    ApiUrls.baseUrl + "/api/transaction/mitransactionid?miTransactionId=";

  public static readonly updateTransaction =
    ApiUrls.baseUrl + "/api/transaction/update/";
  public static readonly updateTransFileUpload =
    ApiUrls.baseUrl + "/api/transaction/upload/";

  public static readonly cancelTransaction =
    ApiUrls.baseUrl + "/api/transaction/cancel/";
  public static readonly reverseTransaction =
    ApiUrls.baseUrl + "/api/transaction/reverse/";
  public static readonly correctTransaction =
    ApiUrls.baseUrl + "/api/transaction/correct/";
  public static readonly MiBulkTransaction =
    ApiUrls.baseUrl + "/api/transaction/mi-bulk-tickets";
  public static readonly duplicateTransaction =
    ApiUrls.baseUrl + "/api/transaction/duplicate/";
  public static readonly MiTransaction =
    ApiUrls.baseUrl + "/api/transaction/mark-as-mi/";

  public static readonly miCountries =
    ApiUrls.baseUrl + "/api/miconfiguration/countries";
  public static readonly miAirportSites =
    ApiUrls.baseUrl + "/api/miconfiguration/airports";
  public static readonly miCustomers =
    ApiUrls.baseUrl + "/api/miconfiguration/customers";
  public static readonly miMissingFileConfig = ApiUrls.baseUrl + '/api/miconfiguration/missingfileconfig';
  public static readonly addorupdatemissingfileconfig = ApiUrls.baseUrl + '/api/miconfiguration/addorupdatemissingfileconfig';
  public static readonly dashboardMissingTransactionDates = ApiUrls.baseUrl + '/api/dashboard/missingtransactiondates';
  public static readonly miAirportCustomers =
    ApiUrls.baseUrl + "/api/miconfiguration/airportcustomers";
  public static readonly miCustomersAndCountries =
    ApiUrls.baseUrl + "/api/miconfiguration/customersandcountries";
  public static readonly addorupdatecustomer =
    ApiUrls.baseUrl + "/api/miconfiguration/addorupdatecustomer";
  public static readonly addorupdatecountry =
    ApiUrls.baseUrl + "/api/miconfiguration/addorupdatecountry";
  public static readonly addorupdateairport =
    ApiUrls.baseUrl + "/api/miconfiguration/addorupdateairport";
  public static readonly addorupdateairportcustomer =
    ApiUrls.baseUrl + "/api/miconfiguration/addorupdateairportcustomer";

  public static readonly dashboardDetails =
    ApiUrls.baseUrl + "/api/dashboard/details";

  public static readonly userBasic =
    ApiUrls.baseUrl + "/api/transaction/users/basic";
  public static readonly userPermissions =
    ApiUrls.baseUrl + "/api/transaction/users/permissions";
  public static readonly customeraccountnumber =
    ApiUrls.baseUrl + "/api/transaction/customeraccountnumber";

  public static readonly fileDownload =
    ApiUrls.baseUrl + "/api/transaction/download";
  public static readonly logout = ApiUrls.baseUrl + "/api/transaction/logout";

  public static readonly fileFusion = ApiUrls.baseUrl + "/api/filefusion";
  public static readonly fileFusionUpload =
    ApiUrls.baseUrl + "/api/filefusion/fileupload";
  public static readonly fileFusionDownload =
    ApiUrls.baseUrl + "/api/filefusion/filedownload/";
  public static readonly fileError =
    ApiUrls.baseUrl + "/api/filefusion/fileerror?fileId=";
  public static readonly contentError =
    ApiUrls.baseUrl + "/api/filefusion/contenterror?fileId=";
  public static readonly fusionTemplate = "/default_template.xlxs";

  public static readonly reportMasterData =
    ApiUrls.baseUrl + "/api/report/masterdata";
  public static readonly reportList =
    ApiUrls.baseUrl + "/api/report/reportlist";
  public static readonly report = ApiUrls.baseUrl + "/api/report";
  public static readonly runReport = ApiUrls.baseUrl + "/api/report/run";
  public static readonly paymentTypes =
    ApiUrls.baseUrl + "/api/report/paymenttypes";
}
